import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/lib/auth";
import Header from "@/components/Header";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Centers from "@/pages/Centers";
import CenterDetail from "@/pages/CenterDetail";
import MyBookings from "@/pages/MyBookings";
import OwnerDashboard from "@/pages/OwnerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import HowItWorks from "@/pages/HowItWorks";
import Contact from "@/pages/Contact";

function Protected({ children, roles }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="p-10 text-muted-foreground">Loading…</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
    return children;
}

function AppShell() {
    return (
        <>
            <Header />
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/centers" element={<Centers />} />
                <Route path="/centers/:id" element={<CenterDetail />} />
                <Route path="/my-bookings" element={<Protected><MyBookings /></Protected>} />
                <Route path="/owner" element={<Protected roles={["owner", "admin"]}><OwnerDashboard /></Protected>} />
                <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
        </>
    );
}

export default function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <AppShell />
                    <Toaster position="top-right" richColors closeButton />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}
